import React from 'react'
import { observer } from 'mobx-react-lite'

import { Box, FormControl, FormHelperText, Grid, InputLabel, Typography } from '@material-ui/core'

import { MyServerTable } from './MyServerTable'
import { WbProductsTrashedFilter } from './WbProductsTrashedFilter'
import { StoreTableHasMsProductFilter } from './StoreTableHasMsProductFilter'
import { ExportFileKind, ExportToExcelButton } from './ExportToExcelButton'

import { WbProductsTableData } from '../store/productStore'

import { TableColumn } from '../types/tableTypes'
import { WbProductColumnId } from '../types/wbColumns'
import { WbProductModel } from '../server/mpsklad_core/Models/WbProductModel'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import { BootstrapInput } from './BootstrapInput'

import { useApi } from '../hooks/storeHook'

export type WbProductsTableProps = {
  products: WbProductsTableData

  columns: Array<TableColumn<WbProductColumnId, WbProductModel>>

  accountId?: number
  accountName?: string
}

export const WbProductsTable =
  observer(
    ({products, columns, accountId, accountName}: WbProductsTableProps) => {
      const classes = useStyles()
      const api = useApi()

      return (
        <Grid item lg={12} xl={12}>
          <Box className={clsx(classes.container, 'default-border')}>
            <Box paddingTop={1} marginY={2} marginLeft={2} display="flex" alignItems="center">
              <Typography className={classes.label}>
                Товары
              </Typography>

              {
                accountId !== undefined &&
                <Box marginLeft={2}>
                  <ExportToExcelButton
                    fileKind={ExportFileKind.Products}
                    columns={columns}
                    accountName={accountName}
                    makeExportRequest={columnIds => api.product.exportWbToExcel({
                      ...products.getExportOptions(),
                      accountId,
                      columnIds
                    })}
                  />
                </Box>
              }

              <Box marginLeft={25}>
                <Box>
                  <FormControl fullWidth>
                    <InputLabel shrink htmlFor="search-wb-products">
                      Поиск
                    </InputLabel>

                    <BootstrapInput
                      id="search-wb-products"
                      placeholder="Поиск"
                      onChange={e => products.setGlobalFilter(e.target.value)}
                      inputProps={{'aria-label': 'Поиск'}}
                      fullWidth
                    />

                    <FormHelperText className={classes.input}>
                      Id / Код размера (chrtId) / Артикул / Наименование / Штрихкод
                    </FormHelperText>
                  </FormControl>
                </Box>
              </Box>

              <Box marginLeft={5}>
                <StoreTableHasMsProductFilter products={products}/>
              </Box>

              <Box marginLeft={5}>
                <WbProductsTrashedFilter products={products}/>
              </Box>
            </Box>

            <MyServerTable
              tableProps={{size: 'small'}}
              table={products}
              columns={columns}
              labelNoRows="Товаров нет"
              labelNotFound="Товары не найдены"
              labelRowsPerPage="Товаров на странице:"
            />
          </Box>
        </Grid>
      )
    })

const useStyles = makeStyles(() => ({
  container: {
    minWidth: 'calc(100vw - 390px)',
    borderRadius: 12,
    padding: '15px 15px 15px 30px'
  },
  label: {
    fontSize: 14,
    padding: 10
  },
  input: {
    fontSize: 12
  }
}))